























import { computed, defineComponent, inject, ref } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import Fa6SolidCaretDown from '~icons/fa6-solid/caret-down'
import Fa6SolidCaretUp from '~icons/fa6-solid/caret-up'
import { useI18n } from '~/composables/i18n'
import { MappedProduct } from '~/types/product/productTypes'

export default defineComponent({
  components: { Fa6SolidCaretDown, Fa6SolidCaretUp },
  setup() {
    const { t } = useI18n()

    const currentProduct = ref(inject('currentProduct', {}) as MappedProduct)
    const conjugates = ref(currentProduct.value.attributes?.conjugates ?? {})
    const chimerics = ref(currentProduct.value.attributes?.chimerics ?? [])

    const isCaretDown = ref(true)
    const isParentProduct = ref(conjugates.value.isParent)
    const parentConjugate = ref(conjugates.value.parent)
    const isChimericChild = ref(currentProduct.value.attributes?.isChimericChild)

    const displayCondition = ref((isParentProduct.value || isChimericChild.value) && chimerics.value.length > 0)

    const caretClick = () => {
      isCaretDown.value = !isCaretDown.value
    }

    const sortedProducts = computed(() => {
      if (isChimericChild.value && parentConjugate.value?.['host-species']) {
        return [parentConjugate.value, ...chimerics.value].sort((a, b) =>
          a['host-species']!.localeCompare(b['host-species']!)
        )
      }
      // chimerics are sorted by default on BE
      return chimerics.value
    })

    return {
      t,
      isEmpty,
      conjugates,
      displayCondition,
      isParentProduct,
      isChimericChild,
      isCaretDown,
      caretClick,
      sortedProducts,
      parentConjugate,
    }
  },
})
